<template>
  <v-dialog :value="isOpen" max-width="800px" @input="!$event && $emit('close-certificate-dialog')">
    <v-card class="pa-2">
      <v-card-title>
        <v-row class="ma-2" justify="center">
          <h3 class="main--text">
            {{ showExtendedOptions ? translations.certificates : translations.downloadCertificates }}
          </h3>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-list>
          <!-- alternate row background -->
          <v-list-item v-for="(pileLocalUnitProject, index) of localUnitProjectsList" :key="pileLocalUnitProject.id" :class="{ 'grey lighten-4': index % 2 === 1 }">
            <v-row no-gutters class="align-center flex-nowrap">
              <!-- localUnit / project: full name, wraps instead of being truncated -->
              <v-col class="py-2 pr-3">
                <v-list-item-title class="text-wrap">{{ pileLocalUnitProject.localUnit ? pileLocalUnitProject.localUnit.name : (pileLocalUnitProject.project.keyCode + " - " + pileLocalUnitProject.project.label) }}</v-list-item-title>
              </v-col>

              <!-- part -->
              <v-col cols="auto" class="pr-3">
                <v-list-item-title>{{ pileLocalUnitProject.part ? pileLocalUnitProject.part.keyCode : "" }}</v-list-item-title>
              </v-col>

              <!-- certificate actions -->
              <v-col cols="auto" class="d-flex align-center">
                <!-- document -->
                <v-checkbox v-if="showExtendedOptions" class="ma-0 pa-0" :disabled="pileLocalUnitProject.certificate" :input-value="pileLocalUnitProject.document" color="main" :ripple="false" hide-details @change="sendCheckboxUpdatedEvent($event, pileLocalUnitProject)"></v-checkbox>

                <!-- upload -->
                <v-btn icon v-if="showExtendedOptions" @click="sendUploadCertificateEvent(pileLocalUnitProject)">
                  <v-icon>
                    {{ icons.mdiUpload }}
                  </v-icon>
                </v-btn>

                <!-- download -->
                <v-btn :disabled="!pileLocalUnitProject.certificate" icon :href="pileLocalUnitProject.certificateBase64" :download="pileLocalUnitProject.certificateName">
                  <v-icon color="red">
                    {{ icons.mdiFilePdfOutline }}
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <p v-if="!localUnitProjectsList.length" class="ma-0 pa-0 text-center">{{ translations.noItemsFound }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { translations } from "@/utils/common";
import { mdiFilePdfOutline, mdiUpload } from "@mdi/js";

export default {
  name: "CertificateDialog",

  props: {
    pileLocalUnitProjects: {
      type: Array,
      required: true,
      dafault: () => []
    },
    open: {
      type: Boolean,
      default: false
    },
    extendedOptions: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isOpen: false,
    localUnitProjectsList: [],
    showExtendedOptions: false
  }),

  methods: {
    sendCheckboxUpdatedEvent(value, item) {
      item.pileLocalUnitProjectId = item.id;
      this.$emit('checkbox-updated-event', {value: value, item: item});
    },

    sendUploadCertificateEvent(item) {
      this.$emit('upload-certificate', item)
    }
  },

  computed: {
    translations: () => translations,

    icons: () => ({
      mdiFilePdfOutline,
      mdiUpload
    })
  },

  // immediate: the dialog can be mounted already open (v-if in the parent)
  watch: {
    open: {
      immediate: true,
      handler() {
        this.isOpen = this.open;
      }
    },

    pileLocalUnitProjects: {
      immediate: true,
      handler() {
        // sorted by local unit name (project: keyCode - label), then part
        const label = plp => plp.localUnit ? plp.localUnit.name : (plp.project ? plp.project.keyCode + " - " + plp.project.label : "");
        this.localUnitProjectsList = [...(this.pileLocalUnitProjects || [])].sort((a, b) =>
          label(a).localeCompare(label(b), "it", { numeric: true, sensitivity: "base" })
            || (a.part?.keyCode || "").localeCompare(b.part?.keyCode || "", "it", { numeric: true }));
      }
    },

    extendedOptions: {
      immediate: true,
      handler() {
        this.showExtendedOptions = this.extendedOptions;
      }
    },
  }
}
</script>
